import { Fragment } from "react";
import { Icon, type IconName } from "@-/dev.improve.haniverse.components.ui.icon";
import {
  PRIMARY_NAVIGATION_DESTINATION_OPTIONS,
  type PrimaryNavigationDestination,
} from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables.user";
import {
  SettingsRow,
  SettingsRowGroup,
  SettingsRowSeparator,
} from "@-/dev.improve.haniverse.routes.nav.app.settings._components.settings-row";
import { useAdminPrimaryNavigationDestinationPageNavigator } from "#use-admin-primary-navigation-destination-page-navigator";

const destinationMeta: Record<PrimaryNavigationDestination, { icon: IconName; label: string }> = {
  browse: { icon: "MdGridView", label: "Browse" },
  changelog: { icon: "MdHistory", label: "Changelog" },
  collections: { icon: "MdCollectionsBookmark", label: "Collections" },
  cookbook: { icon: "MdMenuBook", label: "Cookbook" },
  decks: { icon: "GoStack", label: "Deck" },
  idioms: { icon: "HiChatBubbleLeftRight", label: "Idioms" },
  learn: { icon: "MdSchool", label: "Learn" },
  map: { icon: "MdMap", label: "Map" },
  search: { icon: "MdSearch", label: "Search" },
  settings: { icon: "MdSettings", label: "Settings" },
  stats: { icon: "MdInsights", label: "Stats" },
};

/**
 * Every primary-navigation destination as an Admin opener — including temporarily hidden
 * strip/drawer tabs (Idioms, Collections) so admins can still reach them.
 */
export function AdminPrimaryNavigationDestinationsSection() {
  const destinationNavigator = useAdminPrimaryNavigationDestinationPageNavigator();

  return (
    <SettingsRowGroup
      footer="Opens any app tab directly. Idioms and Collections are hidden from the strip and drawer for now; use these rows to reach them."
      title="Open destinations"
    >
      {PRIMARY_NAVIGATION_DESTINATION_OPTIONS.map((destination, index) => {
        const { icon, label } = destinationMeta[destination];
        return (
          <Fragment key={destination}>
            {index > 0 ? <SettingsRowSeparator /> : null}
            <SettingsRow
              icon={icon}
              label={label}
              onPress={() => destinationNavigator.navigate.mutate(destination)}
              testID={`admin-open-destination-${destination}`}
              trailing={<Icon color="#9CA3AF" name="MdChevronRight" size={20} />}
            />
          </Fragment>
        );
      })}
    </SettingsRowGroup>
  );
}
